<template>
    <div class="mt-10">
        <p class="subscription-text-md">
            {{
                t(
                    order.count_paid_payment
                        ? "payments.subscription_will_be_prolonged_until"
                        : "payments.subscription_active_until"
                )
            }}
            <span class="accent-date">{{ formatdate(order.subscription_info.next_payment) }}</span>
        </p>
        <p v-if="order.subscription_info.subscription_type_payment_by_merchant === 2" class="subscription-text-sm mt-5">
            {{ t("payments.subscription_extension_auto_email_will_be_sent") }}
        </p>
        <p v-else class="subscription-text-sm mt-5">
            {{ t("payments.subscription_extension_email_will_be_sent") }}
        </p>
    </div>
</template>

<script>
import formatDate from "@mixins/formatDate"

export default {
    name: "PublicOfferSubscriptionInfo",
    props: {
        order: {
            type: Object,
            required: true
        }
    },
    mixins: [formatDate]
}
</script>

<style lang="sass" scoped>
@import 'resources/sass/vars'

.subscription-text
    font-weight: 400
    line-height: 130%
.subscription-text-md
    @extend .subscription-text
    font-size: 13px
    color: $text-accent-color
.subscription-text-sm
    @extend .subscription-text
    font-size: 10px
    color: $text-color2
.accent-date
    color: $accent-color5
</style>
